import '@adornis/bh-matching-config/components/buddy-page-admin-legal-pages.js';
import '@adornis/bh-matching-config/components/buddy-page-data-privacy.js';
import '@adornis/bh-matching-config/components/buddy-page-imprint.js';
import '@adornis/bh-matching-export/components/buddy-page-export.js';
import { MatchingPageAdmin } from '@adornis/bh-matching-frontend-entrypoint/matching-page-admin.js';
import '@adornis/bh-matching-mails/components/buddy-page-mails.js';
// import '@adornis/bh-matching-matches/components/buddy-page-manage-matches.js';
// import '@adornis/bh-matching-matches/components/buddy-page-matching.js';
// import '@adornis/bh-matching-signup/components/buddy-page-signup.js';
// import '@adornis/bh-matching-signup/components/buddy-page-success-register.js';
import { MatchingTimeframeAPI } from '@adornis/bh-matching-timeframes/api/MatchingTimeframeAPI.js';
import '@adornis/bh-matching-timeframes/components/matching-page-timeframes.js';
import '@adornis/bh-matching-timeframes/components/matching-semester-selection.js';
import '@adornis/bh-matching-user/components/buddy-page-admin-users.js';
import { MatchingPermission } from '@adornis/bh-matching-user/permissions.js';
import { MatchingRole } from '@adornis/bh-matching-user/roles.js';
import '@adornis/buchungsheld-components/authentication/bh-login.js';
import '@adornis/buchungsheld-theme/components/tr-button-small.js';
import '@adornis/buchungsheld-theme/components/tr-loader.js';
import '@adornis/buchungsheld-theme/components/tr-tooltip.js';
import '@adornis/buchungsheld-theme/fonts/fonts.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-empty-placeholder.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import '@adornis/chemistry/elements/components/x-section.js';
import '@adornis/fonts/fonts.js';
import { goTo } from '@adornis/router/client/open-href.js';
import { clientTranslator } from '@adornis/translation-core/client/clientTranslator.js';
import { Language } from '@adornis/translation-core/languages.js';
import '@adornis/translation/client/translation-editor.js';
import '@adornis/user-forms/x-login.js';
import { logout } from '@adornis/users/client/loginFunctions.js';
import { GLOBAL_CONTEXT } from '@adornis/users/db/a-roles.js';
import { html, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { filter, of, switchMap } from 'rxjs';
import logo from '../assets/buchungsheld_logo_small.png';
import '../components/matching-hautnah-page-banner.js';
import { adminRouter } from '../main-element.js';

/*
 * @element matching-hautnah-page-admin
 */
@customElement('matching-hautnah-page-admin')
export class MatchingFuldaPageAdmin extends MatchingPageAdmin {
  @state() protected readonly _showCleanupBanner = new RXController(
    this,
    this._currUser.observable.pipe(
      filter(Boolean),
      switchMap(user => {
        const hasPermission = user.hasPermission(MatchingPermission.CREATE_EDIT_DELETE_USERS, GLOBAL_CONTEXT);
        return hasPermission ? MatchingTimeframeAPI.findForCleanup()() : of([]);
      }),
    ),
  );

  override _sidebar() {
    if (!this._currUser.value) return nothing;
    if (!this.showSidebar) return nothing;
    return this._currUser.value && this._currUser.value.roles.find(role => role.name === MatchingRole.ADMIN)
      ? html`
          <tr-sidebar
            .isNarrow=${this.showSidebar}
            ${css({
              minWidth: this.sizes.sidebarMinWidth,
              background: this.colors.tone.snowWhite,
              boxShadow: `0 0 16px -8px`,
            })}
            .routes=${Object.entries(adminRouter.routes).map(([key, value]) => ({ name: key, ...(value as any) }))}
          >
            <img src=${logo} slot="logo" ${css({ width: '30%', margin: 'auto' })} />
            <x-flex padding="md"> <matching-semester-selection></matching-semester-selection> </x-flex>
            <x-flex slot="bottom" horizontal space="sm">
              <tr-button-small
                icon="logout"
                mode="outline"
                .color=${this.colors.tone.black}
                .action=${() => logout().then(() => goTo('/'))}
              >
                <tr-tooltip> Ausloggen </tr-tooltip>
              </tr-button-small>
              <tr-button-small
                .color=${this.colors.tone.black}
                mode="outline"
                .action=${() => {
                  if (this._language.value === Language.GERMAN) {
                    void clientTranslator.selectLanguage(Language.ENGLISH);
                  } else {
                    void clientTranslator.selectLanguage(Language.GERMAN);
                  }

                  // this is need because else not every translation changes (i.e. sidebar items)
                  window.location.reload();
                }}
              >
                <tr-text>${this._language.value.toUpperCase()}</tr-text>
                <tr-tooltip .text=${clientTranslator.translate('change_language')}></tr-tooltip>
              </tr-button-small>
            </x-flex>
          </tr-sidebar>
        `
      : nothing;
  }

  protected _renderTimeframeCleanupBanner() {
    if (this._showCleanupBanner.isLoading || this._showCleanupBanner.value?.length === 0) return nothing;

    return html` <matching-hautnah-page-banner></matching-hautnah-page-banner> `;
  }

  override _content() {
    return html` <tr-flex flex> ${this._renderTimeframeCleanupBanner()} ${super._content()} </tr-flex> `;
  }
}
